// discover
export const INIT_DISCOVER = 'initDiscover';

// discover layout
export const GET_LAYOUTID = {
  LOADING: 'getLayoutIDLoading',
  SUCCESS: 'getLayoutIDSuccess',
  FAIL: 'getLayoutIDFail'
};

// discover layout expertList
export const GET_EXPERT_LIST = {
  LOADING: 'getExpertListLoading',
  SUCCESS: 'getExpertListSuccess',
  FAIL: 'getExpertListFail',
  SET_LIKE: 'setExpertListLike'
};

// discover layout popularPoi
export const GET_POPULAR_POI = {
  LOADING: 'getPopularPoiLoading',
  SUCCESS: 'getPopularPoiSuccess',
  FAIL: 'getPopularPoiFail',
  SET_LIKE: 'setPopularPoiLike'
};

// discover layout popularItinerary
export const GET_POPULAR_ITINERARY = {
  LOADING: 'getPopularItineraryLoading',
  SUCCESS: 'getPopularItinerarySuccess',
  FAIL: 'getPopularItineraryFail',
  SET_LIKE: 'setPopularItineraryLike'
};

// discover layout featureList
export const GET_FEATURE_LIST = {
  LOADING: 'getFeatureListLoading',
  SUCCESS: 'getFeatureListSuccess',
  FAIL: 'getFeatureListFail',
  SET_LIKE: 'setFeatureListLike'
};

// discover layout popularJournal
export const GET_POPULAR_JOURNAL = {
  LOADING: 'getPopularJournalLoading',
  SUCCESS: 'getPopularJournalSuccess',
  FAIL: 'getPopularJournalFAIL',
  NEXT_SUCCESS: 'getNextPopularJournalSuccess',
  NEXT_FAIL: 'getNextPopularJournalFail',
  SET_LIKE: 'setPopularJournalLike'
};

// discover layout latestJournal
export const GET_LATEST_JOURNAL = {
  LOADING: 'getLatestJournalLoading',
  SUCCESS: 'getLatestJournalSuccess',
  FAIL: 'getLatestJournalFail',
  SET_LIKE: 'setLatestJournalLike'
};

// discover layout topicCarousel
export const GET_DISCOVER_TOPIC_01 = {
  LOADING: 'getDiscoverTopicCarouselLoading',
  SUCCESS: 'getDiscoverTopicCarouselSuccess',
  FAIL: 'getDiscoverTopicCarouselFail'
};

// discover layout productBanner
export const GET_PRODUCT_BANNER = {
  LOADING: 'getProductBannerLoading',
  SUCCESS: 'getProductBannerSuccess',
  FAIL: 'getProductBannerFail'
};

// discover layout productList
export const GET_PRODUCT_LIST = {
  LOADING: 'getProductListLoading',
  SUCCESS: 'getProductListSuccess',
  FAIL: 'getProductListFail'
};

// discover layout following
export const GET_FOLLOWING = {
  LOADING: 'getFollowingLoading',
  SUCCESS: 'getFollowingSuccess',
  FAIL: 'getFollowingFail'
};

// discover layout city
export const GET_CITY = {
  LOADING: 'getCityLoading',
  SUCCESS: 'getCitySuccess',
  FAIL: 'getCityFail',
  NEXT_SUCCESS: 'getNextFollowingSuccess',
  NEXT_FAIL: 'getNextFollowingFail',
  SET_LIKE: 'setNextFollowingLike'
};

// discover action buttons (i.e. Wifi/SIM, Car Rental, Hotel, etc)
export const GET_ACTION_BUTTONS = {
  LOADING: 'getActionButtonsLoading',
  SUCCESS: 'getActionButtonsSuccess',
  FAIL: 'getActionButtonsFail'
};

// discover future count -> headline
export const GET_FUTURE_COUNT = {
  LOADING: 'getFutureCountLoading',
  SUCCESS: 'getFutureCountSuccess',
  FAIL: 'getFutureCountFail'
};
